/**
 * Glasronde 0.9.240 punt 2 (Frank, 4 nov 2026): de omschrijving die NovaMund zelf invult bij een import van GitHub
 * (services/repo_import.py: "Van github.com/<eigenaar>/<repo>"), in de taal van de app. Die tekst staat OPGESLAGEN
 * in de repo, dus vertalen gebeurt bij het tonen, ook voor repo's die al bestaan. Een omschrijving die iemand zelf
 * schreef, blijft precies zoals hij is. PUUR.
 */
export function repoOmschrijving(tekst, taal) {
  if (taal !== "en" || !tekst) return tekst;
  const m = /^Van (github\.com\/\S+)$/.exec(tekst);
  return m ? `From ${m[1]}` : tekst;
}
